import { useTranslation } from 'react-i18next'

const FeedbackActionBar = ({ currentState, actionTaken, hasEmotion, isPrimary, isStudent, onPressSendMessage, onPressAssignAction, onPressTakeAction }) => {
    const { t } = useTranslation()

    return (
        <div className="feedback-modal-action-sector mb-5">
            {hasEmotion && !isPrimary && isStudent && (
                <div
                    className="feedback-modal-buttons"
                    style={{ backgroundColor: currentState === 'sendPrivateMessage' ? '#5E639B' : 'transparent' }}
                    onClick={onPressSendMessage}
                    id="send-message-button"
                >
                    <p style={{ textAlign: 'center', color: currentState === 'sendPrivateMessage' ? '#FDDF6D' : '#5E639B' }}>{t('sendMessage')}</p>
                    {currentState === 'sendPrivateMessage' && <div className="selected-button-arrow-down"></div>}
                </div>
            )}
            <div className="flex-1"></div>
            {isStudent && (
                <div
                    className="feedback-modal-buttons ml-2"
                    style={{
                        backgroundColor: currentState === 'assignAction' ? '#5E639B' : 'transparent',
                        marginRight: 10,
                    }}
                    onClick={onPressAssignAction}
                    id="assign-action-button"
                >
                    <p style={{ textAlign: 'center', color: currentState === 'assignAction' ? '#FDDF6D' : '#5E639B' }}>{t('assignAction')}</p>
                    {currentState === 'assignAction' && <div className="selected-button-arrow-down"></div>}
                </div>
            )}
            {hasEmotion && (
                <div
                    className={`feedback-modal-buttons ${actionTaken ? 'disabled' : ''}`}
                    style={{
                        backgroundColor: currentState === 'takingAction' ? '#5E639B' : 'transparent',
                        cursor: actionTaken ? 'default' : 'pointer',
                    }}
                    onClick={onPressTakeAction}
                    id="take-action-button"
                >
                    <p style={{ textAlign: 'center', color: currentState === 'takingAction' ? '#FDDF6D' : '#5E639B' }}>{actionTaken ? t('actionTaken') : t('iWillTakeAction')}</p>
                    {currentState === 'takingAction' && <div className="selected-button-arrow-down"></div>}
                </div>
            )}
        </div>
    )
}

export default FeedbackActionBar
